import React, { useState, useEffect } from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import DocPageHeader from 'components/docs/DocPageHeader';
import DocPagesLayout from 'layouts/DocPagesLayout';
import ScorecardAssignmentForm from 'components/forms/ScorecardAssignmentForm';
import ScorecardAssignmentForm2 from 'components/forms/ScorecardAssignmentForm2';
import RiskAssignmentForm from 'components/forms/RiskAssignmentForm';
import RiskAssignmentForm2 from 'components/forms/RiskAssignmentForm2';
import { Col, Row } from 'react-bootstrap';
import scorecard from 'assets/img/spot-illustrations/scorecards.png';
import risk from 'assets/img/spot-illustrations/risk.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightLeft } from '@fortawesome/free-solid-svg-icons';

const ScorecardAndRiskAssignment = () => {
  const [showFirstFormScorecard, setShowFirstFormScorecard] = useState(true);
  const [showFirstFormRisk, setShowFirstFormRisk] = useState(true);
  const [bounceScorecard, setBounceScorecard] = useState(true);
  const [bounceRisk, setBounceRisk] = useState(true);

  useEffect(() => {
    // Animación para scorecards
    const toggleBounceScorecard = () => {
      setBounceScorecard(true);
      setTimeout(() => {
        setBounceScorecard(false);
      }, 5000);
    };

    // Animación para riesgos
    const toggleBounceRisk = () => {
      setBounceRisk(true);
      setTimeout(() => {
        setBounceRisk(false);
      }, 5000);
    };

    toggleBounceScorecard();
    toggleBounceRisk();

    const intervalId = setInterval(() => {
      toggleBounceScorecard();
      toggleBounceRisk();
    }, 15000);

    return () => clearInterval(intervalId);
  }, []);

  const toggleFormScorecard = () => {
    setShowFirstFormScorecard(prev => !prev);
  };

  const toggleFormRisk = () => {
    setShowFirstFormRisk(prev => !prev);
  };

  return (
    <div>
      <DocPageHeader title="Campaign Quality & Risk Configuration" />
      <DocPagesLayout>
        <PhoenixDocCard className="mb-6">
          <PhoenixDocCard.Header
            title="Assign Scorecards"
            noPreview
            className="pb-1 pt-3"
          >
            <Row>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="mb-0">
                    To assign scorecards to campaigns, you can use either of the
                    two methods below. The first allows you to select a campaign
                    and assign multiple scorecards to it. The second lets you
                    select a scorecard and assign it to multiple campaigns.
                  </p>
                </div>
              </Col>
              <Col xs="auto" className="order-xxl-2">
                <div className="x-6">
                  <img src={scorecard} alt="" />
                </div>
              </Col>
            </Row>
          </PhoenixDocCard.Header>
          <PhoenixDocCard.Body className="pt-0">
            <Row className="pb-2 text-center">
              <Col className="d-flex flex-column align-items-center">
                <span
                  className="text-primary"
                  onClick={toggleFormScorecard}
                  style={{ cursor: 'pointer' }}
                >
                  <FontAwesomeIcon
                    icon={faRightLeft}
                    className="me-5 fs-8"
                    bounce={bounceScorecard}
                  />
                </span>
              </Col>
            </Row>
            <Row className="col-md-12">
              <div className="card card-container border border-0">
                <div className="form-group pb-3 align-items-end">
                  {showFirstFormScorecard ? (
                    <ScorecardAssignmentForm />
                  ) : (
                    <ScorecardAssignmentForm2 />
                  )}
                </div>
              </div>
            </Row>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        <PhoenixDocCard className="mb-0">
          <PhoenixDocCard.Header
            title="Assign Risks"
            noPreview
            className="pb-1 pt-3"
          >
            <Row>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="mb-0">
                    Select which risk elements should be analyzed for each
                    campaign. The system will automatically detect these risks
                    during call processing. Risks are valuated from 1 to 5. Only
                    risks with severity 4 or 5 will require manual review.
                  </p>
                </div>
              </Col>
              <Col xs="auto" className="order-xxl-2">
                <div className="x-6">
                  <img src={risk} alt="" />
                </div>
              </Col>
            </Row>
          </PhoenixDocCard.Header>
          <PhoenixDocCard.Body className="pt-0">
            <Row className="pb-2 text-center">
              <Col className="d-flex flex-column align-items-center">
                <span
                  className="text-primary"
                  onClick={toggleFormRisk}
                  style={{ cursor: 'pointer' }}
                >
                  <FontAwesomeIcon
                    icon={faRightLeft}
                    className="me-5 fs-8"
                    bounce={bounceRisk}
                  />
                </span>
              </Col>
            </Row>
            <Row className="col-md-12">
              <div className="card card-container border border-0">
                <div className="form-group pb-3 align-items-end">
                  {showFirstFormRisk ? (
                    <RiskAssignmentForm />
                  ) : (
                    <RiskAssignmentForm2 />
                  )}
                </div>
              </div>
            </Row>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
      </DocPagesLayout>
    </div>
  );
};

export default ScorecardAndRiskAssignment;
